import { useCircleV4 } from "@/react/hooks/useCircleV4";
import type { Person } from "@/react/types/AudienceList";

import { MobileCommunityMember as MobileCommunityMemberCompass } from "./MobileCommunityMemberCompass";
import { MobileCommunityMember as MobileCommunityMemberUiKit } from "./MobileCommunityMemberUiKit";

export const MobileCommunityMember = ({
  canReceiveDmFromCurrentMember,
  communityMember,
  isLastItem,
}: {
  canReceiveDmFromCurrentMember: boolean;
  communityMember: Person;
  isLastItem: boolean;
}) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <MobileCommunityMemberCompass
        canReceiveDmFromCurrentMember={canReceiveDmFromCurrentMember}
        communityMember={communityMember}
      />
    );
  }

  return (
    <MobileCommunityMemberUiKit
      canReceiveDmFromCurrentMember={canReceiveDmFromCurrentMember}
      communityMember={communityMember}
      isLastItem={isLastItem}
    />
  );
};
